import './Header.scss';
import Image from '../Image/Image';
import { selectCommon } from '../../store/commonSlice';
import { useAppSelector } from '../../store/hooks';
import Link from '../Link/Link';

type HeaderProps = { children?: JSX.Element };

function Header({ children }: HeaderProps): JSX.Element {
  const common = useAppSelector(selectCommon);
  const accountType = common.accountType;
  const accountName = common.referenceData!.accountTypes.find((account) => {
    return account.value === accountType;
  })?.label;

  return (
    <header>
      <div className='header'>
        <ul className='header__list'>
          <li>
            <Link href='https://www.newcastlepermanent.com.au/'>
              <Image
                classes='header__logo'
                alt='Newcastle Permanent logo'
                name='npbs-logo.svg'
                width='118'
                height='40'
              />
            </Link>
          </li>
          <li className='header__divider'></li>
          {children ? (
            <li className='header__account'>
              <span className='header__account-name'>{children}</span>
            </li>
          ) : (
            <li className='header__account'>
              <span className='header__account-name'>
                {accountName}
                {accountType !== 'FIA' &&
                  accountType !== 'CC' &&
                  accountType !== 'MA' && <> Account</>}
              </span>
              <br />
              <span>Application</span>
            </li>
          )}
        </ul>
      </div>
    </header>
  );
}

export default Header;
